import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-table',
    templateUrl: 'detail-table.component.html',
    styleUrls: ['./detail-table.component.scss'],
    standalone: false,
})
export class DetailTableComponent {
    @Input()
    public titleLeft?: string;

    @Input()
    public titleRight?: string;
}
